import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    background: '#FFFFFF',
    boxShadow: '0px 0px 6px #00000029',
    borderRadius: '8px',
    top: '66px',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 1
  },
  calendarWrapper: {
    display: 'flex',

    '& .MuiPickersDay-current': {
      color: 'rgba(0, 0, 0, 0.87)'
    }
  },
  timeWrapper: {
    borderLeft: '1px solid #EEEEEE',
    display: 'flex',
    margin: '50px 0',
    padding: '0 20px',
    alignItems: 'center',
    justifyContent: 'space-between',
    minWidth: '100px',

    '& svg': {
      color: '#C9C9C9',
    },
    '& p': {
      color: '#1D2634',
      fontWeight: 'bold',
      display: 'flex',
      alignItems: 'center'
    }
  },
  time: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  inputWrapper: {
    width: '20px',

    '& input': {
      textAlign: 'center',
      color: '#1D2634',
      fontWeight: 'bold'
    },
    '& input::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      'margin': 0
    },
    '& input::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      'margin': 0
    },
    '& input[type=number]': {
      '-moz-appearance': 'textfield'
    }
  },
  underline: {
    '&:before': {
      borderBottom: 'none'
    }
  },
  input: {
    textAlign: 'center'
  },
  boxWrap: {
    width: '20px',
    height: '32px'
  },
  buttonGroup: {
    borderTop: '1px solid #EEEEEE',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px'
  },
  button: {
    width: '20%',
    height: '30px',
    margin: 0,
    alignItems: 'center',
    padding: 0
  },
  pointer: {
    cursor: 'pointer'
  }
}))

export { useStyles }